var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseDialogState } from "./BaseDialog";
import { action, makeObservable, observable } from 'mobx';
export class LetrLinksDialogState {
    constructor() {
        this.dialogstate = new BaseDialogState();
        this.creating = false;
        this.name = "";
        this.errormessage = "";
        this.roleid = "";
        this.allowedit = false;
        makeObservable(this);
        this.dialogstate.setOkLabel("Create");
        this.dialogstate.setHeaderLabel("Create Link");
        this.dialogstate.onOk = () => {
            var _a;
            if (!this.name.trim()) {
                this.setErrorMessage("Please enter reference name for link");
            }
            else {
                this.setErrorMessage("");
                this.setCreating(true);
                (_a = this.createlink) === null || _a === void 0 ? void 0 : _a.call(this, this.name, this.allowedit, this.roleid);
            }
        };
    }
    setAllowEdit(edit) {
        this.allowedit = edit;
    }
    setRoleid(id) {
        this.roleid = id;
    }
    setErrorMessage(msg) {
        this.errormessage = msg;
    }
    setCreating(cre) {
        this.creating = cre;
    }
    setName(name) {
        this.name = name;
    }
    setOpen(open) {
        this.dialogstate.setOpen(open);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrLinksDialogState.prototype, "creating", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrLinksDialogState.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrLinksDialogState.prototype, "errormessage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrLinksDialogState.prototype, "roleid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrLinksDialogState.prototype, "allowedit", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrLinksDialogState.prototype, "setAllowEdit", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrLinksDialogState.prototype, "setRoleid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrLinksDialogState.prototype, "setErrorMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrLinksDialogState.prototype, "setCreating", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrLinksDialogState.prototype, "setName", null);
